import { useEffect } from "react";
import { observer } from "mobx-react";
import { CloseSquare } from "iconsax-react";
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
//import styles from '../shared/shared.module.scss';
import {
    PayPalScriptProvider,
    PayPalButtons,
    usePayPalScriptReducer
} from "@paypal/react-paypal-js";

// This values are the props in the UI
const currency = "USD";
const style = { "layout": "vertical" };

const ChargeModal = observer(({ show, setShow, amount, onSuccess, payload }) => {

    return (
        <Dialog
            open={show}
            onClose={() => {}}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            maxWidth='xs'
            fullWidth
        >
            <DialogTitle>
                <Typography fontWeight={600}>Payment</Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                <PayPalScriptProvider
                    options={{
                        "client-id": "test",
                        components: "buttons",
                        currency: "USD"
                    }}
                >
                    <ButtonWrapper
                        currency={currency}
                        showSpinner={true}
                        amount={amount}
                        onSuccess={() => { onSuccess(); setShow(false); }}
                        payload={payload}
                    />
                </PayPalScriptProvider>
            </DialogContent>
        </Dialog>
    );
});


// Custom component to wrap the PayPalButtons and handle currency changes
const ButtonWrapper = ({ currency, showSpinner, amount, onSuccess, payload }) => {
    // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
    // This is the main reason to wrap the PayPalButtons in a new component
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

    useEffect(() => {
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: currency,
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currency, showSpinner]);


    return (<>
        {(showSpinner && isPending) && <div className="spinner" />}
        <PayPalButtons
            style={style}
            disabled={false}
            forceReRender={[amount, currency, style]}
            fundingSource={undefined}
            createOrder={(data, actions) => {
                return actions.order
                    .create({
                        purchase_units: [
                            {
                                amount: {
                                    currency_code: currency,
                                    value: amount,
                                },
                            },
                        ],
                    })
                    .then((orderId) => {
                        // Your code here after create the order
                        return orderId;
                    });
            }}
            onApprove={function (data, actions) {
                return actions.order.capture().then(async function () {
                    if(payload.type === 'membership'){
                        await payload.uiStore.updateMembership(payload.id);
                        await payload.uiStore.getMembership();
                    }
                    
                    if(payload.type === 'wallet-charge'){
                        await payload.uiStore.updateBalance(amount);
                        await payload.uiStore.getBalance();
                    }
                    
                    onSuccess();
                });
            }}
        />
    </>
    );
}

export default ChargeModal;
